const RatesInfoBox = ({ text }) => {
  if (!text) return null;

  return (
    <div className="rates-info-box">
      <p>{text}</p>
    </div>
  );
};

export default RatesInfoBox;
